<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>波次校验</div>
      <el-button
        v-if="openWeight === OPEN_WEIGHT.OPEN"
        type="info"
        style="margin-left: 20px"
        @click="connectDigitalScale"
        >连接电子秤
      </el-button>
    </div>
    <div class="tally-header">
      <div class="input-desk-no">
        <el-button
          :disabled="$store.getters.tallyLock"
          class="c-background"
          style="background-color: rgb(0, 140, 0)"
          @click="deskClick()"
        >
          <span style="color: #fff">&nbsp;工作台</span>
        </el-button>
      </div>
      <div v-if="deskNo" class="desk-no">
        <el-button type="info">{{ deskNo }}</el-button>
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入波次号：">
                  <el-input
                    ref="inputRef"
                    v-model="form.wave_picking_no"
                    placeholder="波次号"
                    :disabled="inputRef_disabled"
                    @keyup.native.enter="getGoods"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getGoods">
                    获取波次信息
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" plain @click="exitCheck">
                    退出校验
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <span style="color: red">{{
                    resData && resData.prior_tip
                  }}</span>
                </el-form-item>
              </el-form>
            </div>
            <audio id="audio_error" preload="auto">
              <source
                src="../../assets/music/check_error.wav"
                type="audio/wav"
              />
            </audio>
            <audio id="audio_success" preload="auto">
              <source
                src="../../assets/music/check_success.wav"
                type="audio/wav"
              />
            </audio>
          </div>
        </el-collapse-transition>
      </el-col>
      <el-col>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入Dbid：">
                  <el-input
                    ref="inputRefDbid"
                    v-model="form.qrCode"
                    placeholder="dbid=123456"
                    @keyup.native.enter="check"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="check">校验</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          v-if="resData"
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
          :span="24"
        >
          数据列表：总数：{{ resData.all_num }},已校验：{{ resData.check_num }}
        </div>
        <div style="margin-bottom: 0; font-size: 16px !important">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="300"
            :data="resData.goods"
            tooltip-effect="dark"
            style="width: 100%; font-size: 18px !important"
            :cell-class-name="changeCellStyle"
          >
            <el-table-column
              align="center"
              prop="goods_no"
              label="商品货号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="co_val"
              label="颜色"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="si_val"
              label="尺码"
            ></el-table-column>
            <el-table-column align="center" label="校验数量">
              <template slot-scope="scope">
                <div>
                  <span style="font-size: 20px; font-weight: 500">{{
                    scope.row.dbid_num
                  }}</span
                  >/{{ scope.row.wave_picking_info_num }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="msgVisible" width="30%" center>
      <p style="text-align: center; font-size: 20px">错误提示</p>
      <p style="text-align: center; font-size: 18px; color: red">
        {{ msg }}
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button id="msg" type="button" @click="closeMsgBox">
          知道了
        </el-button>
        <el-button type="button" @click="exitCheck">退出校验</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="check_over_show"
      width="30%"
      :close-on-click-modal="false"
      :show-close="false"
      center
    >
      <div style="text-align: center; font-size: 16px">
        {{ check_over_msg }}
      </div>
      <div>计算（预估）重量：{{ preWeight }}g</div>
      <div>称重重量：{{ currentWeight * 1000 }}g</div>
      <el-input
        ref="over_input_enter"
        v-model="saoma_enter.str"
        style="margin-top: 20px"
        @keyup.native.enter="checkCompeleteClose"
        @keyup.native.space="checkCompeleteClose"
      ></el-input>
    </el-dialog>

    <span>
      {{ handleDataSort }}
    </span>
  </div>
</template>

<script>
import { trimString } from "@/tool/helper.js";
import { cookieCacheSet, cookieCacheGet } from "../../tool/cache.js";

const OPEN_WEIGHT = {
  OPEN: "1",
  CLOSED: "2",
};
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
      vm.hasDeskNo();
    });
  },
  data() {
    return {
      isConnecting: false, // 是否连接中
      OPEN_WEIGHT,
      isSupportWeight: false, // 是否支持使用电子秤
      currentWeight: "", // 电子秤称重重量
      preWeight: "",
      weightRate: "",
      openWeight: OPEN_WEIGHT.CLOSED, // 校验称重开关，1开，2关
      resData: null,
      form: {
        wave_picking_no: "",
        qrCode: "",
      },
      loading: false,
      print_loading: false,
      tableLoading: false,
      url: "/storage/WavePicking/isChecking",
      status: "",
      curPage: 1,
      filterFold: false,
      websock: null,
      msgVisible: false,
      msgVisibleResource: 1, // 弹窗来源 {1:波次号 2:dbid}
      msg: "",
      deskNo: "",
      inputRef_disabled: false,
      check_over_msg: "",
      check_over_show: false,
      saoma_enter: {
        str: "",
      },
      isChecking: false,
    };
  },
  computed: {
    filteredForm() {
      Object.keys(this.form).forEach((key) => {
        if ([undefined, "", null].includes(this.form[key])) {
          delete this.form[key];
        }
      });
      return this.form;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    handleDataSort() {
      if (!this.resData) {
        return;
      }
      this.resData.goods.forEach((item, index) => {
        if (item.dbid_num === item.wave_picking_info_num) {
          this.$set(this.resData.goods[index], "sort", 1);
        } else {
          this.$set(this.resData.goods[index], "sort", 0);
        }
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.resData.goods.sort((a, b) => {
        return a.sort - b.sort;
      });
    },
  },
  destroyed() {
    // 页面销毁时关闭长连接
    this.websocketclose();
  },
  created() {
    this.isSupportWeight = "serial" in navigator;
    this.initWebSocket();
  },
  methods: {
    async connectDigitalScale() {
      if (!this.isSupportWeight) {
        this.$message.error("当前浏览器不支持连接电子秤");
        return;
      }
      const onDisconnect = () => {
        this.$message.info("电子秤已断开连接");
        this.isConnecting = false;
      };

      const onConnect = async () => {
        this.$message.info("电子秤已连接");
        this.isConnecting = true;
      };

      navigator.serial.addEventListener("disconnect", onDisconnect);
      navigator.serial.addEventListener("connect", onConnect);

      try {
        const port = await navigator.serial.requestPort();
        await port.open({ baudRate: 9600 });
        this.$message.info("电子秤已连接");
        this.isConnecting = true;

        const reader = port.readable.getReader();
        while (true) {
          const { value, done } = await reader.read();
          if (done) {
            reader.releaseLock();
            break;
          }

          let weight = new TextDecoder().decode(value);
          if (weight) {
            weight = weight.trim();
            this.currentWeight = weight.slice(0, -2);
            console.log("实时称重结果", this.currentWeight);
          }
        }
      } catch (error) {
        // Handle errors appropriately
        console.error(error);
      } finally {
        // Clean up event listeners
        navigator.serial.removeEventListener("disconnect", onDisconnect);
        navigator.serial.removeEventListener("connect", onConnect);
      }
    },

    hasDeskNo() {
      this.deskNo = cookieCacheGet("deskNoCheck");
      if (!this.deskNo) {
        this.deskClick();
      }
    },
    // websocket相关
    initWebSocket() {
      // 初始化weosocket
      const ishttps = document.location.protocol === "https:";
      let wsuri;
      if (ishttps) {
        wsuri = "wss://localhost:13529"; // https wss地址
      } else {
        wsuri = "ws://localhost:13528"; // ws地址
      }

      this.websock = new WebSocket(wsuri);
      // this.websocket.onopen = this.websocketonopen;

      this.websock.onerror = this.websocketonerror;

      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonerror() {
      // 错误
    },
    websocketonmessage(e) {
      const obj = JSON.parse(e.data);
      if (obj.cmd === "print") {
        if (obj.status === "failed") {
          this.$confirm(obj.msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        }
      }
    },
    websocketsend(agentData) {
      // 数据发送
      this.websock.send(agentData);
      // 发送完就清空，其它波次校验
      this.form.qrCode = "";
      this.form.wave_picking_no = "";
      this.inputRef_disabled = false;
      setTimeout(() => {
        this.$refs.inputRef.$el.children[0].focus();
      }, 200);
    },
    websocketclose() {
      // 关闭
    },

    getGoods() {
      // 没有输入波次号就不要提交了
      if (!this.form.wave_picking_no) {
        this.$refs.inputRef.$el.children[0].focus();
        return;
      }
      this.$http
        .post("/storage/WavePicking/getWavePickingGoods", this.filteredForm)
        .then((res) => {
          if (res.data.code === 200) {
            this.inputRef_disabled = true;
            if (res.data.data.action === "reCheck") {
              this.$confirm(`此波次单已完成校验?`, "", {
                distinguishCancelAndClose: true,
                confirmButtonText: "重新校验",
                cancelButtonText: "获取面单",
                type: "warning",
              })
                .then(() => {
                  this.$http
                    .post("/storage/WavePicking/reCheck", {
                      wave_picking_no: res.data.data.wave_picking_no,
                      wave_picking_id: res.data.data.wave_picking_id,
                    })
                    .then((resp) => {
                      if (resp.data.code === 200) {
                        this.form.wave_picking_no =
                          resp.data.data.wave_picking_no;
                        this.getGoods();
                      } else {
                        this.msg = resp.data.msg;
                        this.msgVisible = true;
                        // this.$message.error(res.data.msg);
                      }
                    });
                })
                .catch((action) => {
                  if (action === "cancel") {
                    this.printWayBill();
                  }
                });
            } else if (res.data.data.action === "printSuccess") {
              this.msg = "该波次单已经打印面单";
              this.$alert(this.msg, "提示", {
                confirmButtonText: "知道了",
                showClose: false,
              }).then(() => {
                this.form.qrCode = "";
                this.form.wave_picking_no = "";
                this.inputRef_disabled = false;
                this.msgVisible = false;
                this.resData = null;
                setTimeout(() => {
                  this.$refs.inputRef.$el.children[0].focus();
                }, 200);
              });
            } else if (this.form.wave_picking_no.indexOf("dbid=") !== -1) {
              const qrCode = this.form.wave_picking_no;
              this.form = {
                qrCode: "",
                wave_picking_no: "",
              };
              this.form.wave_picking_no = res.data.data.wave_picking_no;
              this.form.qrCode = qrCode;
              this.$refs.inputRefDbid.$el.children[0].focus();
              this.check();
            } else {
              this.$refs.inputRefDbid.$el.children[0].focus();
              this.resData = res.data.data;
              this.preWeight = res?.data?.data?.pre_weight;
              this.weightRate = res?.data?.data?.weight_rate;
              this.openWeight = res?.data?.data?.open_weight;
              // 如果该波次号需要称重
              if (this.openWeight === this.OPEN_WEIGHT.OPEN) {
                // 当前浏览器是否支持称重
                if (this.isSupportWeight) {
                  // 未连接，执行连接
                  if (!this.isConnecting) {
                    // this.$message.warning("请先连接电子秤");
                    this.connectDigitalScale();
                  }
                } else {
                  this.$message.error("当前浏览器不支持连接电子秤");
                }
              }
            }
          } else {
            this.msg = res.data.msg;
            this.msgVisible = true;
            // this.$message.error(res.data.msg);
          }
        });
    },
    check() {
      if (this.openWeight === OPEN_WEIGHT.OPEN && !this.isConnecting) {
        this.$message.warning("请连接电子秤");
        return;
      }
      if (!this.deskNo) {
        this.deskClick();
        return;
      }
      this.form.deskNo = this.deskNo;
      this.isChecking = true;
      this.$http
        .post("/storage/WavePicking/check", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.form.qrCode = "";
            this.msg = res.data.msg;
            this.msgVisible = true;
            this.$refs.inputRefDbid.$el.children[0].blur();
            this.msgVisibleResource = 2;
            this.addVoice("error");
          } else {
            this.addVoice("success");
            if (res.data.data.check_num === res.data.data?.all_num) {
              this.resData = res.data.data;
              // 如果已开启称重开关
              if (this.openWeight === OPEN_WEIGHT.OPEN) {
                this.checkCompelete();
              } else if (`${res.data.data.print_status}` !== "1") {
                // 未打印,获取失败,取消面单的可以打
                this.printWayBill();
              }
            } else {
              this.form.qrCode = "";
              this.resData = res.data.data;
              this.$message.success("校验成功");
            }
          }
        })
        .finally(() => {
          this.isChecking = false;
        });
    },

    checkCompeleteClose() {
      if (this.openWeight === OPEN_WEIGHT.OPEN) {
        if (!this.currentWeight) {
          this.$message.error("包裹请称重");
          return;
        }
      }
      if (this.saoma_enter.str.trim() !== "") {
        if (this.saoma_enter.str.trim() !== "enter") {
          this.$set(this.saoma_enter, "str", "");
          this.$message.error("提交二维码有误.");
          return;
        }
      }
      this.$set(this.saoma_enter, "str", "");
      this.check_over_msg = "";
      this.check_over_show = false;
      this.$refs.inputRef.$el.children[0].focus();
      if (this.openWeight === OPEN_WEIGHT.OPEN) {
        const diffValue = Math.abs(
          Number(this.currentWeight) * 1000 - Number(this.preWeight)
        );
        console.log("diffValue", diffValue);
        const rate = diffValue / Number(this.preWeight);
        console.log("计算的rate", rate);
        console.log("weightRate", Number(this.weightRate) / 100);
        console.log("是否超过", rate > Number(this.weightRate) / 100);
        if (rate > Number(this.weightRate) / 100) {
          this.$confirm("称重异常，请重新称重", "提示", {
            confirmButtonText: "坚定提交",
            showCancelButton: false,
            type: "warning",
          }).then(() => {
            this.printWayBill();
          });
        } else {
          this.printWayBill();
        }
      }
    },
    // 校验完成之后的提示
    checkCompelete() {
      // 当开启称重且只有一件时，不需要弹框回车确认
      if (this.resData.all_num === 1 && this.openWeight !== OPEN_WEIGHT.OPEN) {
        return;
      }
      this.$set(this.saoma_enter, "str", "");
      this.$refs.inputRefDbid.$el.children[0].blur();
      this.check_over_msg = `校验已完成，共${this.resData.check_num}件`;
      this.check_over_show = true;
      setTimeout(() => {
        this.$refs.over_input_enter.$el.children[0].focus();
        this.$refs.over_input_enter.$el.children[0].select();
      }, 500);
    },
    addVoice(t) {
      document.getElementById(`audio_${t}`).play();
    },
    // 退出校验
    exitCheck() {
      this.$http
        .post("/storage/WavePicking/exitCheck", this.filteredForm)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg);
            this.form.qrCode = "";
            this.form.wave_picking_no = "";
            this.inputRef_disabled = false;
            this.msgVisible = false;
            this.resData = null;
            setTimeout(() => {
              this.$refs.inputRef.$el.children[0].focus();
            }, 200);
          } else {
            this.msg = res.data.msg;
            this.msgVisible = true;
          }
        });
    },
    printWayBill() {
      this.$http
        .post("/storage/WavePicking/getWayBill", {
          ...this.filteredForm,
          weight: Number(this.currentWeight) * 1000,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            if (`${res.data.msg}` === "400" || `${res.data.msg}` === "402") {
              this.$confirm(
                `调用菜鸟接口出错，请检查菜鸟后台是否已绑定了此快递以及余额是否大于0，或重新获取面单。`,
                "",
                {
                  confirmButtonText: "重新获取",
                  cancelButtonText: "校验其它",
                  type: "warning",
                }
              )
                .then(() => {
                  this.printWayBill();
                })
                .catch(() => {
                  this.form.qrCode = "";
                  this.form.wave_picking_no = "";
                  this.inputRef_disabled = false;
                  setTimeout(() => {
                    this.$refs.inputRef.$el.children[0].focus();
                  }, 200);
                });
            } else {
              this.msg = res.data.msg;
              this.msgVisible = true;
            }
          } else if (`${res.data.data.print_status}` === "1") {
            this.$http
              .post("/erp/WavePicking/rePirnt", {
                wave_picking_no: res.data.data.wave_picking_no,
              })
              .then((resp) => {
                if (resp.data.code !== 200) {
                  this.msg = resp.data.msg;
                  this.msgVisible = true;
                } else {
                  this.websocketsend(JSON.stringify(resp.data.data.printData));
                  if (this.openWeight === OPEN_WEIGHT.OPEN) {
                    this.check_over_show = false;
                    this.currentWeight = "";
                  }
                }
              });
            this.checkCompelete();
          } else if (
            `${res.data.data.print_status}` === "5" ||
            `${res.data.data.print_status}` === "4" ||
            `${res.data.data.print_status}` === "6"
          ) {
            this.$confirm(
              `此波次单快递公司为：${res.data.data.shipping_company}`,
              "提示",
              {
                confirmButtonText: "确定",
                type: "info",
              }
            ).then(() => {
              this.form.qrCode = "";
              this.form.wave_picking_no = "";
              this.inputRef_disabled = false;
              setTimeout(() => {
                this.$refs.inputRef.$el.children[0].focus();
              }, 200);
            });
          }
        });
    },
    fetchData(showLoading) {
      this.deskNo = cookieCacheGet("deskNoCheck");
      this.$refs.inputRef.$el.children[0].focus();
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (typeof res.data.data.wave_picking_no !== "undefined") {
          this.$confirm(
            `您有正在校验的波次(${res.data.data.wave_picking_no})，是否继续?`,
            "",
            {
              confirmButtonText: "继续校验",
              cancelButtonText: "退出校验",
              type: "warning",
            }
          )
            .then(() => {
              this.$http
                .post("/storage/WavePicking/getWavePickingGoods", {
                  wave_picking_no: res.data?.data?.wave_picking_no,
                })
                .then((resp) => {
                  if (resp.data.code === 200) {
                    this.inputRef_disabled = true;
                    this.form.wave_picking_no =
                      resp?.data?.data.wave_picking_no;
                    this.$refs.inputRefDbid.$el.children[0].focus();
                    this.resData = resp?.data?.data;
                  } else {
                    this.msg = resp.data.msg;
                    this.msgVisible = true;
                  }
                });
            })
            .catch(() => {
              this.$http
                .post("/storage/WavePicking/exitCheck", {
                  wave_picking_no: res?.data?.data?.wave_picking_no,
                })
                .then((resp) => {
                  if (resp.data.code === 200) {
                    this.$refs.inputRef.$el.children[0].focus();
                    this.$message.success(resp.data.msg);
                  } else {
                    this.msg = resp.data.msg;
                    this.msgVisible = true;
                  }
                });
            });
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      let dbid = "";
      if (typeof this.form.dbid !== "undefined") {
        dbid = this.form.dbid.split("dbid=");
      }

      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (
          typeof this.form.dbid !== "undefined" &&
          typeof dbid[1] !== "undefined"
        ) {
          this.form.dbid = dbid[1];
        }
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          this.resData = [];
        } else {
          this.resData = res.data.data;
        }
      });
    },
    deskClick() {
      this.$prompt("", "工作台", {
        confirmButtonText: "确定",
      })
        .then(({ value }) => {
          this.verifyDeskNo(value);
        })
        .catch(() => {
          if (!this.deskNo) {
            this.deskClick();
          }
        });
    },
    verifyDeskNo(value) {
      const val = trimString(value);
      if (!val) {
        this.deskClick();
        this.$message.error("请输入工作台号");
      }
      if (Object.keys(val).length !== 8) {
        this.deskClick();
        this.$message.error("工作台号码有误,请检查");
      }

      this.$http
        .post("/erp/Tally/verifyDeskNo", { desk_no: val })
        .then((res) => {
          if (res.data.code !== 200) {
            this.deskClick();
            this.$message.error(res.data.msg);
          }
          cookieCacheSet("deskNoCheck", val, 64800);
          this.deskNo = val;
        });
    },
    closeMsgBox() {
      this.msgVisible = false;
      if (this.msgVisibleResource === 2) {
        this.$refs.inputRefDbid.$el.children[0].focus();
      }
    },
    changeCellStyle({ row }) {
      if (row.dbid_num === row.wave_picking_info_num) {
        return "success-cell";
      }
      return "";
    },
  },
};
</script>
<style>
.success-cell {
  background-color: #cbefba !important;
  background: #cbefba !important;
}
</style>
<style scoped>
.row {
  height: 60px;
}

.tally-header {
  padding-top: 10px;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/Check.vue